angular.module('am4').controller('imageEditCtrl', function($element, $scope, errorService, safeLogsService, imageService, $stateParams, $rootScope) {
    var that = this,
        imgService = imageService($stateParams.type),
        getImg = function() {
            imgService.getImage($stateParams.id, $stateParams.imageType)
            .then(function(selectedImage) {
                if (selectedImage.length) {
                    that.selectedImage = selectedImage[0].url;
                    that.selectedImageId = selectedImage[0].id;
                }

                that.upload = function(file) {
                    that.isSaving = true;

                    imgService.postImage($stateParams.id, $stateParams.imageType, file)
                    .then(function(image) {
                        that.imageForm.$setPristine();

                        that.selectedImage = that.selectedImagePreview;
                        that.selectedImagePreview = null;

                        if ($stateParams.imageType === 'splash') {
                            that.splash = image.url;
                        } else {
                            that.logo = image.url;
                        }

                        that.selectedImageId = image.id;
                    })
                    .finally(function() {
                        that.isSaving = false;
                    })
                    .catch(function(e) {
                        errorService.addError('PHOTO_UPLOAD_ERROR', e);
                    });
                };

                that.removePhoto = function() {
                    that.isDeleting = true;

                    imgService.deleteImage($stateParams.id, $stateParams.imageType, that.selectedImageId)
                    .then(function() {
                        that.selectedImage = null;
                    })
                    .catch(function(e) {
                        errorService.addError('PHOTO_DELETE_ERROR', e);
                    })
                    .finally(function() {
                        that.isDeleting = false;
                    });
                };

                that.clearPhoto = function() {
                    that.imageForm.$setPristine();
                    $($element.find('#modal-imageEdit-input')[0]).val(''); // eslint-disable-line no-undef
                    that.imageForm.image.$setValidity('size', true);
                    that.selectedImagePreview = null;
                };

                that.selectFile = function(files) {
                    that.imageForm.$setDirty();

                    var reader = new FileReader();
                    that.imageForm.image.$setValidity('inProgressUpload', false);

                    reader.onload = function(event) {
                        that.imageForm.image.$setValidity('inProgressUpload', true);

                        that.selectedImagePreview = event.target.result;

                        // 5 megabytes
                        that.imageForm.image.$setValidity('size', files[0].size < 5 * 1000 * 1000);

                        that.newImageSrc = files[0];
                        $scope.$apply();
                    };
                    reader.readAsDataURL(files[0]);
                };
            })
            .catch(function(e) {
                errorService.addError('GET_IMAGE_ERROR', e);
            })
            .finally(function() {
                that.loading = false;
            });
        },
        orgId;

    that.imageType = $stateParams.imageType;
    that.loading = true;
    that.orgFacType = $stateParams.type;

    that.canEditImage = function() {
        if ($stateParams.type === 'facilities') {
            return $rootScope.userPermissions.indexOf('FACILITY_TASKS') > -1;
        } else if ($stateParams.type === 'organizations') {
            return $rootScope.userPermissions.indexOf('ORG_TASKS') > -1 && $rootScope.adminOrganizations && $rootScope.adminOrganizations.includes($scope.org.id);
        }
        return false;
    };

    if ($stateParams.imageType === 'splash') {
        that.editTranslation = 'EDIT_SPLASH';
    } else {
        that.editTranslation = 'CUSTOM_LOGO';
    }

    if ($stateParams.type === 'facilities') {
        orgId = $scope.fac.data.organization_id;
        imageService('organizations').getImage(orgId, $stateParams.imageType).then(function() {
            getImg(); // OK, go get facility image
            that.orgId = orgId;
        })
        .catch(function(e) {
            getImg(); // Couldn't confirm existance of org images; might as well fetch facility media
            safeLogsService.log('GET_IMAGE_ERROR', e);
        });
    } else {
        getImg();
    }
});



// WEBPACK FOOTER //
// ./src/app/controllers/imageEditCtrl.js